export default __webpack_public_path__ + "assets/fonts/Nunito-Black-971e6a87.woff";